import { render, staticRenderFns } from "./Youth.vue?vue&type=template&id=4cada3a4&scoped=true&"
import script from "./Youth.vue?vue&type=script&lang=js&"
export * from "./Youth.vue?vue&type=script&lang=js&"
import style0 from "./Youth.vue?vue&type=style&index=0&id=4cada3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cada3a4",
  null
  
)

export default component.exports